import { useSuspenseQuery } from '@tanstack/react-query';

import { useBoundStore } from 'app/store';

import { getHsptlzFormCreatedFileInfo } from '../api';

export const useGetHsptlzFormCreatedFileInfo = (contentCode) => {
  const { hspId, usrId, hsptlzRsvNo } = useBoundStore((state) => state['hsptlzForm'].serviceParams);

  const { data } = useSuspenseQuery({
    queryKey: ['hsptlzFormCreatedFileInfo'],
    queryFn: () => getHsptlzFormCreatedFileInfo({ hspId, usrId, hsptlzRsvNo, contentCode }),
  });

  return data;
};
